import { useState } from "react";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) navigate(`/places?q=${encodeURIComponent(query)}`);
  };

  const tags = ["Kapadokya", "Mardin", "Halfeti", "Ayder Yaylası", "Bozcaada", "Gaziantep"];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Turkey%20landscape%20collage%20Cappadocia%20Mardin%20Bosphorus%20mountains%20sea%20dramatic%20aerial%20view%20stunning%20natural%20beauty%20golden%20hour&width=1600&height=900&seq=hero1&orientation=landscape"
          alt="Türkiye manzarası"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-4 md:px-8 pt-20">
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-1.5 mb-6">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-sparkling-line text-amber-400 text-xs"></i>
          </div>
          <span className="text-white/90 text-xs font-medium">Editörler Tarafından Seçilmiş Destinasyonlar</span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight"
          style={{ fontFamily: "'Playfair Display', serif" }}>
          Türkiye'yi<br />
          <span className="text-amber-400">Gerçekten Keşfedin</span>
        </h1>

        <p className="text-white/80 text-lg md:text-xl max-w-2xl mx-auto mb-10 leading-relaxed">
          Kalabalık turist rotalarının ötesinde, yerel halkın bildiği gizli köşeler,
          editörlerimizin bizzat deneyimlediği restoranlar ve kapsamlı şehir rehberleri.
        </p>

        {/* Search */}
        <form onSubmit={handleSearch} className="max-w-xl mx-auto mb-8">
          <div className="flex items-center bg-white rounded-full overflow-hidden">
            <div className="w-12 h-12 flex items-center justify-center pl-4">
              <i className="ri-search-line text-stone-400 text-lg"></i>
            </div>
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Şehir, yer veya yemek ara..."
              className="flex-1 px-3 py-3 text-sm text-stone-700 outline-none bg-transparent"
            />
            <button
              type="submit"
              className="bg-amber-500 hover:bg-amber-600 text-white font-semibold text-sm px-6 py-3 m-1 rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              Ara
            </button>
          </div>
        </form>

        {/* Quick Tags */}
        <div className="flex flex-wrap justify-center gap-2 mb-16">
          {tags.map((tag) => (
            <button
              key={tag}
              onClick={() => navigate(`/places?q=${encodeURIComponent(tag)}`)}
              className="bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/20 text-white text-xs px-4 py-1.5 rounded-full transition-colors cursor-pointer whitespace-nowrap"
            >
              {tag}
            </button>
          ))}
        </div>

        {/* Stats */}
        <div className="flex flex-wrap justify-center gap-8 md:gap-16">
          {[
            { value: "120+", label: "Gizli Yer" },
            { value: "85+", label: "Restoran" },
            { value: "60+", label: "Makale" },
            { value: "81", label: "İl Kapsama" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-amber-400" style={{ fontFamily: "'Playfair Display', serif" }}>
                {stat.value}
              </div>
              <div className="text-white/60 text-xs mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 animate-bounce">
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white/50 text-lg"></i>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
